import { render, staticRenderFns } from "./ConfirmDialog.component.vue?vue&type=template&id=1985e856"
import script from "./ConfirmDialog.component.vue?vue&type=script&lang=ts"
export * from "./ConfirmDialog.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports